import Vue from "vue";
import Vuex from "vuex";
import VuexPersistence from "vuex-persist";
import localForage from "localforage";
import { clone } from "pouchdb-utils";
import stringify from "json-stringify-safe";

// import the auto exporter
import modules from "./modules/index";
Vue.use(Vuex);
const vuexLocalStorage = new VuexPersistence({
  key: "vuexLocalStorageReduced", // The key to store the state on in the storage provider.
  //storage: window.localStorage, // or window.sessionStorage or localForage
  //localforage
  storage: localForage,
  strictMode: false,
  asyncStorage: true,
  //end localforage
  reducer: (state) =>
    JSON.parse(
      stringify({
        Activites: state.Activites,
        Auth: state.Auth,
        Bailleurs: state.Bailleurs,
        Campagnes: state.Campagnes,
        Communes: state.Communes,
        Counts: state.Counts,
        DetailEtapes: state.DetailEtapes,
        Districts: state.Districts,
        DotationsDeGroupe: state.DotationsDeGroupe,
        EtapeEffective: state.EtapeEffective,
        Etapes: state.Etapes,
        Fiches: state.Fiches,
        Fokontany: state.Fokontany,
        FormationsDeGroupe: state.FormationsDeGroupe,
        PresencesFormationsDeGroupe: state.PresencesFormationsDeGroupe,
        PresencesDotationsDeGroupe: state.PresencesDotationsDeGroupe,
        formations: state.Formations,
        ParcoursEffectif: state.ParcoursEffectif,
        FormationsDeMasse: state.FormationsDeMasse,
        Groupes: state.Groupes,
        HorsGroupe: state.HorsGroupe,
        Membres: state.Membres,
        Menages: state.Menages,
        Mygroupes: state.Mygroupes,
        Parametres: state.Parametres,
        Projets: state.Projets,
        Provinces: state.Provinces,
        Regions: state.Regions,
        Themes: state.Themes,
        TypeDetailEtape: state.TypeDetailEtape,
        RolesHorsGroupe: state.RolesHorsGroupe,
        //Users: state.Users,
        Utils: state.Utils,
      })
    ),
});
export default new Vuex.Store({ modules, plugins: [vuexLocalStorage.plugin] });
